import React from "react";
import { Link, NavLink } from "react-router-dom";
import { getStatus } from "services/getApi";
import { Countdown } from "../../../utils/Countdown";

/* eslint-disable jsx-a11y/anchor-is-valid */
function Navbar({ loading, path1, handleReportPage, handleLogout }) {
    const [time, setTime] = React.useState("00:00:00");


    React.useEffect(() => {
        let validityTime = localStorage.getItem("validityTime");
        setInterval(() => {
            if (!Countdown(validityTime)) {
                getStatus().then(_=> {
                    console.log('ok')
                  })
                  .catch(_=> {
                    handleLogout()
                    localStorage.removeItem("token");
                    localStorage.removeItem("validityTime");
                  })
            } else {
                setTime(Countdown(validityTime))
            }
        }, 1000);
    }, [])

    return (
        <div id="navbarMain" className="border border-[#fff1] navbar bg-base-100 text-primary-content shadow-xl rounded-[15px] w-[99%] sticky top-[0.5%] right-[0.5%]" style={{ zIndex: 9999 }}>
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabindex="0" className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabindex="0" className=" border border-[#fff1] menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        <li><NavLink to='./'>گزارش گیری</NavLink></li>
                        <li><NavLink to='./new-guest'>ثبت مهمان</NavLink></li>
                        <li><NavLink to='./new-factor'>ثبت فاکتور</NavLink></li>
                        <li><NavLink to='./new-store'>ثبت انبار</NavLink></li>
                        <li><NavLink to='./room-price'>مدیریت قیمت اتاق‌ها</NavLink></li>
                    </ul>
                </div>
                <a className="btn btn-ghost normal-case text-xl">هتل داری <span className="text-[14px] mr-1 hidden md:block">(مهمانسرا دانشگاه شمال)</span></a>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal p-0 flex-row-reverse">
                    <li className="li_tab"><NavLink to='./'>آمار اطلاعات</NavLink></li>
                    <li className="li_tab"><NavLink to='./room-price'>مدیریت قیمت اتاق‌ها</NavLink></li>
                    <li className="li_tab"><NavLink to='./print'>گزارش بازه ای</NavLink></li>
                    <li className="li_tab"><NavLink className={path1 == "/new-guest" ? "active" : undefined} to='./new-guest/person'>ثبت مهمان</NavLink></li>
                </ul>
            </div>
            <div className="navbar-end items-center flex">
                <span className=" text-sm p-2 ml-2 mt-2">
                    {time} : زمان اعتبار
                </span>
                {/* <button onClick={handleReportPage} className={`hidden md:flex btn btn-primary ${loading ? "loading" : ""}`} dir="ltr">
                    {
                        loading ?
                            "صبر کن"
                            :
                            <>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-columns-reverse" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M0 .5A.5.5 0 0 1 .5 0h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 .5Zm4 0a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10A.5.5 0 0 1 4 .5Zm-4 2A.5.5 0 0 1 .5 2h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Zm-4 2A.5.5 0 0 1 .5 4h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm-4 2A.5.5 0 0 1 .5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Zm-4 2A.5.5 0 0 1 .5 8h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z" />
                                </svg>
                                &nbsp;
                                 صفحه اصلی
                            </>
                    }
                </button> */}
                <div className="dropdown dropdown-end mr-2">
                    <label tabindex="0" className="btn btn-ghost btn-circle avatar mt-1">
                        <div className="w-10">
                            <img src="https://shomal.ac.ir/wp-content/themes/main-shomal/assets/images/logo.png" />
                        </div>
                    </label>
                    <ul tabindex="0" className="menu menu-compact dropdown-content mt-3 p-2 shadow-xl border border-[#fff1] bg-base-100 rounded-box w-52 !left-0">
                        <li>
                            <Link to="/setting" className="justify-between">
                                تنظیمات
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gear" viewBox="0 0 16 16">
                                    <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
                                    <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
                                </svg>
                            </Link>
                        </li>
                        <li >
                            <label for="my-modal" className="justify-between text-error">
                                خارج شدن از حساب
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-left" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z" />
                                    <path fill-rule="evenodd" d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z" />
                                </svg>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Navbar;
